/**
 * Tiny client for /api/school/* endpoints.
 *
 * Lives next to the routes that use it instead of a global api/ folder
 * because the surface is small and self-contained. If/when more endpoints
 * land, hoist this into a shared client.
 */

const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:3000';

export interface JoinResult {
  classroomId: string;
  classroomName: string;
  currentLessonId: string | null;
}

export async function joinClassroom(code: string): Promise<JoinResult> {
  const res = await fetch(`${apiUrl}/api/school/join`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ code }),
  });
  if (res.status === 404) throw new Error('not_found');
  if (!res.ok) throw new Error('request_failed');
  return (await res.json()) as JoinResult;
}

export interface TeacherUpsertResult {
  teacherId: string;
  displayName: string;
  district: string | null;
}

export async function upsertTeacher(): Promise<TeacherUpsertResult> {
  const res = await fetch(`${apiUrl}/api/school/teacher/upsert`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({}),
  });
  if (!res.ok) throw new Error(`teacher_upsert_failed_${res.status}`);
  return (await res.json()) as TeacherUpsertResult;
}
